import gql from 'graphql-tag'
// import { companyFragment } from '../company/companyFragments'

export const siteSubscriptionFragment = gql`
    fragment siteSubscriptionFragment on SiteSubscription{
        id
        name
        owner {
            id
            name
            email
        }
        type
        company_id
    }
`
export const siteSubscriptionInfoFragment = gql`
    fragment siteSubscriptionInfoFragment on SiteSubscriptionInfo{
        id
        name
        owner {
            id
            name
            email
        }
        type
        company_id
    }
`